import { ErrorView } from './ErrorView.js';

export function NotFoundView(): JSX.Element {
  return (
    <ErrorView
      code="404"
      description="The page you are looking for doesn't exist or may have been moved."
      title="Page not found"
    />
  );
}
